/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import axios from "axios";
import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "Admin settingsManager/services/ThirdPartyService";

export const getThirdPartyApplications = async (platformType) => {
	try {
		let response = await axios.get(`${APIGateways.thirdPartyApplicationsEndpoint}/${platformType}`, {
			headers: await getAuthHeader(),
		});
		return response.data.data;
	} catch (error) {
		v2.error(`Error getting all social media applications`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_THIRD_PARTY_APPLICATIONS_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

export const updateThirdPartyApplications = async (update, original, platformType, configId) => {
	try {
		let response = await axios.post(
			`${APIGateways.thirdPartyApplicationsEndpoint}/${platformType}/${configId}`,
			{ update, original },
			{
				headers: await getAuthHeader(),
			},
		);

		return response.data.update;
	} catch (error) {
		v2.error(`Error updating social media applications`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.UPDATE_THIRD_PARTY_APPLICATIONS_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

export const deleteThirdPartyApplication = async (configId, platform) => {
	try {
		let response = await axios.delete(`${APIGateways.thirdPartyApplicationsEndpoint}/${platform}/${configId}`, {
			headers: await getAuthHeader(),
		});

		return response.data.data;
	} catch (error) {
		v2.error(`Error deleting social media applications`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.DELETE_THIRD_PARTY_APPLICATIONS_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

/**
 * Gets all pinpoint applications from AWS pinpoint api. These are seperate from our own third party application dynamo records.
 * @returns An array of Pinpoint applications.
 */
export const getPinpointApplications = async () => {
	try {
		let response = await axios.get(`${APIGateways.pinpointApplicationsEndpoint}`, {
			headers: await getAuthHeader(),
		});

		return response.data.data;
	} catch (error) {
		v2.error(`Error retrieving all pinpoint applications`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_PINPOINT_APPLICATIONS_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

/**
 * Gets all domains verified in SES
 * @returns An array of domains.
 */
export const getEmailDomains = async () => {
	try {
		let response = await axios.get(`${APIGateways.emailDomainsEndpoint}`, {
			headers: await getAuthHeader(),
		});

		return response.data.domains;
	} catch (error) {
		v2.error(`Error retrieving all email domains`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_EMAIL_DOMAINS_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};
